import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Check from "@mui/icons-material/Check";
import FormControl from "@mui/material/FormControl";
import Checkbox from "react-custom-checkbox";
import {
  useForm,
  FormProvider,
  useFormContext,
  Controller,
} from "react-hook-form";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import Button from "@restart/ui/esm/Button";
import TextField from "@mui/material/TextField";
import { useHistory } from "react-router";
import InputBase from "@mui/material/InputBase";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Col, Container, Dropdown, Form, Image, Row } from "react-bootstrap";
import upload_icon from "../assets/images/upload_icon.png";
import Select1 from "react-select";
import { FiCheck } from "react-icons/fi";
import CheckboxColored from "../Components/CheckboxColored";
import RadioButton from "../Components/RadioButton";
import { dollarRegEx, URL, apiHeader } from "../Config/apiUrl";
import { Get, Post } from "../Axios/AxiosFunctions";
import LocationInput from "../Components/LocationInput";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";

const JobPost = ({ setfooterStyle }) => {
  const user = useSelector((state) => state.authReducer?.user);
  const token = useSelector((state) => state.authReducer?.access_token);
  const history = useHistory();
  const [check, setCheck] = useState({
    Fixed: "false",
    timeLimited: "false",
    fourWeeks: "false",
    eightWeeks: "false",
    twelveWeeks: "false",
  });

  const [formsEmploye, setFormEmployee] = useState("");
  const [jobDuration, setJobDuration] = useState("");
  const [certificateData, setCertificateData] = useState([]);
  const [skillsData, setSkillsData] = useState([]);
  const [skillArray, setSkillArray] = useState([]);
  const [skillsField, setSkillsField] = useState([]);
  const [certificateState, setCertificateState] = useState([]);
  const [timeDuration1, setTimeDuration1] = useState("");
  const [timeDuration2, setTimeDuration2] = useState("");

  const [experienceNewArray, setExperienceNewArray] = useState([]);
  const [experience, setExperience] = useState('');

  const [jobPostData, setJobPostData] = useState({
    title: "",
    workingHours: "",
    description: "",
    min: "",
    max: "",
    // experience: "",
  });

  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");

  const [isApiCall, setIsApiCall] = useState(false);

  // geocoding
  useEffect(() => {
    if (address !== "") {
      var city = "";
      for (var i = 0, len = address.address_components.length; i < len; i++) {
        var ac = address.address_components[i];
        if (ac.types.indexOf("locality") >= 0) city = ac.long_name;
      }

      //only report if we got Good Stuff
      if (city != "") {
        setCity(city);
      }
    }
  }, [address]);

  const getSkills = async () => {
    const url = URL(`admin/get-all-array`);

    const response = await Get(url);

    if (response == undefined) return;

    const newExperience = [];

    response?.data?.data?.experience.map((t) => {
      newExperience.push({ experience: t });
    });
    setExperienceNewArray(newExperience);
  };

  useEffect(() => {
    getSkills();
  }, []);

  const colourOptions = [
    { value: "gold", label: "Building preservation" },
    { value: "silver", label: "DoorVinduer" },
  ];

  // const certificateArray = [];
  const handleChangeField = (e) => {
    const { name, value } = e.target;
    setJobPostData({ ...jobPostData, [name]: value });
  };
  const handleCheckBox = (e) => {
    const { name, value } = e;
    let newCertificates = [...certificateState];
    const index = newCertificates?.findIndex((item) => item === name);

    if (!value) {
      newCertificates?.splice(index, 1);
      setCertificateState([...newCertificates]);
    } else {
      newCertificates?.push(name);
      setCertificateState([...newCertificates]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e;
    console.log(e);
    setJobDuration(name);
  };



  // handleSubmit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const params = {
      ...jobPostData,
      companyId: user?._id,
      userId: user?.UserId?._id,
      jobDuration: jobDuration,
      jobType: formsEmploye?.name,
      address: address?.formatted_address,
      experience: experience?.experience,
      ...(jobDuration == "Time Limited" && { timeDuration1 }),
      ...(jobDuration == "Time Limited" && { timeDuration2 }),
    };



    // validate
    for (let key in params) {
      if (params[key] == "") {
        if (["min", "max"].includes(key)) {
          return toast.warn(`${key} salary can not be empty.`);
        }
        return toast.warn(
          `${key.replace(/([a-z])([A-Z])/g, "$1 $2")} can not be empty.`
        );
      }
    }

    params.lat = address?.geometry?.location?.lat();
    params.lng = address?.geometry?.location?.lng();
    params.city = city;

    // validate skillArray
    if (skillArray.length == 0) {
      return toast.warn("Please specify atleast 1 skill for this job.");
    }

    // validate certificateArray
    if (certificateState.length == 0) {
      return toast.warn("Please specify atleast 1 certificate for this job.");
    }

    // check salaries [should be number]
    if (!dollarRegEx.test(params?.min) || !dollarRegEx.test(params?.max)) {
      return toast.warn("Salary values should be number. (eg: 35000).");
    }

    // min salary should be less
    if (params?.min > params?.max) {
      return toast.warn(
        "Max Saraly amount should be greater than Mix Salary amount."
      );
    }

    params.skillsRequired = skillArray.map((e) => e);
    params.certificatesRequired = certificateState.map((e) => e);

    console.log(params.experience, experience?.experience)
    const url = URL(`job/addjob?experience=${experience?.experience}`);

    setIsApiCall(true);
    const response = await Post(url, params, apiHeader(token));
    setIsApiCall(false);

    if (response !== undefined) {
      toast.success("Job posted successfully.");
      history.replace("/dashboard");
    }
  };

  history.location.pathname ? setfooterStyle(true) : setfooterStyle(false);

  const getdataSkills = URL(`admin/skills-and-jobCertificates`);

  // get data
  const getData = async () => {
    const response = await Get(getdataSkills);
    setCertificateData(response?.data?.data?.certificates);
    setSkillsData(response?.data?.data?.skills);
  };
  useEffect(() => {
    getData();
  }, []);

  const setSelectHandler = (data, customArray, setterCustomArray, setter) => {
    if (data.length > customArray.length) {
      let oldData = customArray.slice();
      oldData.push(data[data.length - 1].skill);
      setterCustomArray(oldData);
    } else {
      let newArray = [];
      data.length > 0 &&
        data.map((item) => {
          newArray.push(item.skill);
        });
      setterCustomArray(newArray);
    }
    setter(data);
  };

  // to scroll top up when page refreshed
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="job_post">
      <Container className="container_733">
        <Row>
          <Col>
            <form onSubmit={handleSubmit}>
              <Col md={12} className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Job title"
                  name="title"
                  onChange={handleChangeField}
                  value={jobPostData.title}
                />
              </Col>
              <Row>
                <Col md={2} className="checkBox_label mb-3 job_form_label">
                  <RadioButton
                    label="Fixed"
                    name="Fixed"
                    handleChange={handleChange}
                  />

                  {/* <CheckboxColored
                  check={check}
                  handleChange={handleChange}
                  name="Fixed"
                  label="Fixed"
                /> */}
                </Col>
                <Col md={2} className="checkBox_label mb-3 job_form_label">
                  {/* <CheckboxColored
                  check={check}
                  handleChange={handleChange}
                  name="timeLimited"
                  label="Time-limited"
                /> */}
                  <RadioButton
                    label="Time-limited "
                    name="Time Limited"
                    handleChange={handleChange}
                  />
                </Col>
              </Row>
              {jobDuration == "Time Limited" && (
                <>
                  <Col md={12} className="mb-3">
                    <Form.Control
                      type="text"
                      onFocus={(e) => (e.target.type = "date")}
                      onBlur={(e) => (e.target.type = "text")}
                      placeholder="Start (Time Duration)"
                      name="timeDuration1"
                      onChange={(e) => setTimeDuration1(e.target.value)}
                      value={timeDuration1}
                      min={moment().format("YYYY-MM-DD")}
                    />
                  </Col>
                  <Col md={12} className="mb-3">
                    <Form.Control
                      type="text"
                      onFocus={(e) => (e.target.type = "date")}
                      onBlur={(e) => (e.target.type = "text")}
                      placeholder="End (Time Duration)"
                      name="timeDuration2"
                      onChange={(e) => setTimeDuration2(e.target.value)}
                      value={timeDuration2}
                      min={moment(timeDuration1).format("YYYY-MM-DD")}
                    />
                  </Col>
                </>
              )}
              {/* <Row>
                <Col md={2} className="checkBox_label mb-3 job_form_label">
                  <CheckboxColored
                  check={check}
                  handleChange={handleChange}
                  name="fourWeeks"
                  label="4 Weeks"
                />
                  <RadioButton
                    label="4 Weeks"
                    name="4 weeks"
                    handleChange={handleChange}
                  />
                </Col>
                <Col md={2} className="checkBox_label mb-3 job_form_label">
                  <CheckboxColored
                  check={check}
                  handleChange={handleChange}
                  name="eightWeeks"
                  label="8 Weeks"
                />
                  <RadioButton
                    label="8 Weeks"
                    name="8 weeks"
                    handleChange={handleChange}
                  />
                </Col>
                <Col md={2} className="checkBox_label mb-3 job_form_label">
                  <CheckboxColored
                  check={check}
                  handleChange={handleChange}
                  name="twelveWeeks"
                  label="12 Weeks"
                />
                  <RadioButton
                    label="12 Weeks"
                    name="12 weeks"
                    handleChange={handleChange}
                  />
                </Col>
              </Row> */}
              <Row>
                <Col md={12} className="mb-3">
                  <div className="new_loc_css">
                    <LocationInput setPlace={setAddress} />
                  </div>
                  {/* <Form.Control
                    type="text"
                    placeholder="Location"
                    name="location"
                    onChange={handleChangeField}
                    value={jobPostData.location}
                  /> */}
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Salary (min)"
                    name="min"
                    onChange={handleChangeField}
                    value={jobPostData.min}
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Salary (max)"
                    name="max"
                    onChange={handleChangeField}
                    value={jobPostData.max}
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Control
                    type="number"
                    placeholder="No of Hours per Week"
                    name="workingHours"
                    onChange={handleChangeField}
                    value={jobPostData.workingHours}
                  />
                </Col>
                {/* <Col md={12} className="mb-3">
                  <Form.Control
                    type="number"
                    placeholder="Experience (in years)"
                    name="experience"
                    onChange={handleChangeField}
                    value={jobPostData.experience}
                  />
                </Col> */}
                <Col md={12} className="mb-3">
                  {/* <label className="mb-2 p-18 gray">Experience</label> */}
                  <Select1
                    defaultValue="test"
                    // onChange={setExperienceField}
                    options={experienceNewArray}
                    value={experience}
                    getOptionLabel={(option) => option.experience}
                    getOptionValue={(option) => option.experience}
                    onChange={(data) => {
                      setExperience(data);
                    }}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Choose Experience"
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={5}
                    placeholder="Description"
                    onChange={handleChangeField}
                    name="description"
                    value={jobPostData.description}
                  />
                </Col>
              </Row>
              <Row>
                <p className="font-22 black mt-3">Certificates Required</p>
              </Row>
              <Row>
                {certificateData?.map((item) => {
                  return (
                    <Col className="checkBox_label mb-3" md={6}>
                      <CheckboxColored
                        handleChange={handleCheckBox}
                        name={item.jobCertificate}
                        label={item.jobCertificate}
                      />
                    </Col>
                  );
                })}
              </Row>

              <Row>
                <Col>
                  <p className="p-22 black mt-3">Skills</p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Select1
                    isMulti
                    name="colors"
                    options={skillsData}
                    getOptionLabel={(option) => option.skill}
                    getOptionValue={(option) => option.skill}
                    onChange={(data) => {
                      setSelectHandler(
                        data,
                        skillArray,
                        setSkillArray,
                        setSkillsField
                      );
                    }}
                    value={skillsField}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <p className="p-22 black mt-3">Forms of Employment:</p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Col className="checkBox_label mb-3" md={12}>
                    <RadioButton
                      name="Try and hire"
                      label="Try and hire"
                      radioType="empployee"
                      setFormEmployee={setFormEmployee}
                      handleChange={handleChange}
                    />
                    {/* <CheckboxColored
                    check={check}
                    handleChange={handleChange}
                    name="timeLimited"
                    label="Try and Hire"
                  /> */}
                  </Col>
                  <Col className="checkBox_label mb-3" md={12}>
                    <RadioButton
                      name="Direct hire"
                      label="Direct hire"
                      radioType="empployee"
                      setFormEmployee={setFormEmployee}
                      handleChange={handleChange}
                    />
                  </Col>
                  <Col className="mb-3 checkBox_label" md={12}>
                    <RadioButton
                      name="Hire directly"
                      label="Hire directly"
                      radioType="empployee"
                      setFormEmployee={setFormEmployee}
                      handleChange={handleChange}
                    />
                  </Col>
                </Col>
              </Row>

              <Col md={12} className="mb-3 mt-3">
                <Button
                  className="step_form_btn_next btn_blue"
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={isApiCall}
                >
                  {!isApiCall ? "Post My Job Ad" : "Please Wait..."}
                </Button>
              </Col>
            </form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default JobPost;
